export default __webpack_public_path__ + "files/RP5_Recommendations_for_the_development_of_tailor_made_policy_instruments_to_boost_bioeconomy.docx";